// ETR
const GET_PENDING_ETR_SETTLEMENTS = `${BACKOFFICE_API_URL}/settlement/etrs`
const ACCEPT_ETR_SETTLEMENTS = `${BACKOFFICE_API_URL}/settlement/etrs/:id/accept`
const REJECT_ETR_SETTLEMENT = `${BACKOFFICE_API_URL}/settlement/etrs/:id/reject`

// ETP
const GET_PENDING_ETP_SETTLEMENTS = `${BACKOFFICE_API_URL}/settlement/etps`
const ACCEPT_ETP_SETTLEMENT = `${BACKOFFICE_API_URL}/settlement/etps/:id/accept`
const REJECT_ETP_SETTLEMENT = `${BACKOFFICE_API_URL}/settlement/etps/:id/reject`

export default {
  GET_PENDING_ETR_SETTLEMENTS,
  ACCEPT_ETR_SETTLEMENTS,
  REJECT_ETR_SETTLEMENT,
  GET_PENDING_ETP_SETTLEMENTS,
  ACCEPT_ETP_SETTLEMENT,
  REJECT_ETP_SETTLEMENT
}
